// @flow
import EMoney from './EMoney';

export default EMoney;
